export default __webpack_public_path__ + "static/sp-button-b65e7b15723b362f719ec361a604f030.png";